interface ConsoleStatsProps {
  totalMessages: number;
  userMessages: number;
  aiMessages: number;
  averageConfidence: number;
  totalSources: number;
}

export default function ConsoleStats({
  totalMessages,
  userMessages,
  aiMessages,
  averageConfidence,
  totalSources,
}: ConsoleStatsProps) {
  const confidencePercent = Math.round(averageConfidence * 100);

  return (
    <div className="flex items-center justify-between text-xs text-gray-600 py-1">
      <div className="flex items-center space-x-4">
        <span><strong>{totalMessages}</strong> msgs ({userMessages}Q/{aiMessages}A)</span>
        <span>Confidence: <strong className="text-green-600">{confidencePercent}%</strong></span>
        <span>Sources: <strong>{totalSources}</strong></span>
      </div>
    </div>
  );
}
